export function hasDistinctDisplayName(displayName: string, nickname: string) {
  return nickname && displayName !== nickname;
}

export function displayNameWithNickname(displayName: string, nickname: string) {
  return hasDistinctDisplayName(displayName, nickname)
    ? `${displayName} (${nickname})`
    : displayName;
}
